module.exports = __webpack_public_path__ + "static/media/usersManual.b559c643.png";